import { api } from '@/lib/api';
import type { CreateServiceRequest, UpdateServiceRequest, VendorService } from './types';

export async function fetch_services(): Promise<VendorService[]> {
  const res = await api.get<VendorService[]>('/vendor/services');
  return res.data;
}

export async function create_service(input: CreateServiceRequest): Promise<VendorService> {
  const res = await api.post<VendorService>('/vendor/services', input);
  return res.data;
}

export async function update_service(id: string, input: UpdateServiceRequest): Promise<VendorService> {
  const res = await api.patch<VendorService>(`/vendor/services/${id}`, input);
  return res.data;
}

export async function delete_service(id: string): Promise<void> {
  await api.delete(`/vendor/services/${id}`);
}
